module.exports = __webpack_public_path__ + "img/Video.fdc5fe28.svg";